import React from "react";
import downloadIcon from "./img/flyer.webp";
import { degrees, PDFDocument, rgb, StandardFonts, TextAlignment } from "pdf-lib";
import fontkit from "@pdf-lib/fontkit";
import { useConfig } from "./ConfigContext";
import { host } from "./globalVariables";
import axios from "axios";
import { api, formatCurrency } from "./pureFunctions";

const fontSize = 14;
const pageXMargin = 24;
const maxLineNumber = 36;

const exportFullPDF = false;
const exportEmptyPDF = false;

export default function DatenblattAushang({
   titleimageURL,
   fieldconfiguration,
   allKacheln,
   ownerData,
   bemerkungsfeld,
   basicdata,
   estatekacheln,
   userObjects,
}) {
   const config = useConfig();

   async function readPDFPages(url) {
      const PdfBytes = await fetch(host + url, { credentials: "include" }).then((data) => data.arrayBuffer());
      const pdfDoc = await PDFDocument.load(PdfBytes);
      return pdfDoc;
   }

   async function createAushang(params) {
      const pdfVorlage =
         basicdata.objektart === "haus" || basicdata.objektart === "wohnung" ? "_" + basicdata.objektart : "";
      const pdfDoc = await readPDFPages("/PDFVorlagen/Aushang" + pdfVorlage + ".pdf");

      console.log(titleimageURL);

      console.log(userObjects);
      console.log(userObjects[basicdata.benutzer].Name);
      console.log(basicdata.benutzer);

      const makler = userObjects[basicdata.benutzer];

      let userImage;
      try {
         const response = await api.get("/NutzerBilder/" + makler.Name + ".png", {
            responseType: "arraybuffer",
         });

         const imageBytes = response.data;
         // 3. Das Bild einbetten (entscheide anhand der URL/Endung ob JPG oder PNG)
         // Tipp: embedJpg funktioniert für .jpg und .jpeg
         userImage = await pdfDoc.embedPng(imageBytes);
      } catch (error) {}

      const proxyUrl = `/api/proxy-image?url=${encodeURIComponent(titleimageURL)}`;

      const response = await api.get(proxyUrl, {
         responseType: "arraybuffer",
      });

      const imageBytes = response.data;
      // 3. Das Bild einbetten (entscheide anhand der URL/Endung ob JPG oder PNG)
      // Tipp: embedJpg funktioniert für .jpg und .jpeg
      const pdfImage = await pdfDoc.embedJpg(imageBytes);

      pdfDoc.registerFontkit(fontkit);
      const ralewayBoldFontBytes = await fetch(host + "/Fonts/Raleway-Bold.ttf").then((res) => res.arrayBuffer());
      const ralewayRegularFontBytes = await fetch(host + "/Fonts/Raleway-Regular.ttf").then((res) => res.arrayBuffer());
      const ralewayBoldFont = await pdfDoc.embedFont(ralewayBoldFontBytes);
      const ralewayRegularFont = await pdfDoc.embedFont(ralewayRegularFontBytes);
      const pages = pdfDoc.getPages();
      const firstPage = pages[0];
      // const helveticaFont = await pdfDoc.embedFont(StandardFonts.Helvetica)

      // Get the width and height of the first page
      const { width, height } = firstPage.getSize();
      console.log(width + " " + height);
      let xpadding = 29;
      firstPage.drawImage(pdfImage, {
         x: xpadding, //firstPage.getWidth() / 2 - pdfImage.width / 2,
         y: height - 328, //firstPage.getHeight() / 2 - pdfImage.height / 2,
         width: width - 2 * xpadding, //pdfImage.width,
         height: (2 * (width - 2 * xpadding)) / 3,
      });

      if (userImage) {
         firstPage.drawImage(userImage, {
            x: 290, //firstPage.getWidth() / 2 - pdfImage.width / 2,
            y: 0, //firstPage.getHeight() / 2 - pdfImage.height / 2,
            // width: userImage.width,
            height: userImage.height * 0.08,
            width: userImage.width * 0.08,
         });
      }

      firstPage.drawText(makler ? makler.Vorname + " " + makler.Nachname : "", {
         x: 146,
         y: height - 563,
         size: 9,
         font: ralewayRegularFont,
         color: rgb(1, 1, 1),
      });

      basicdata.objektnr_extern &&
         firstPage.drawText(basicdata.objektnr_extern, {
            x: 368,
            y: height - 81.5,
            size: 9,
            font: ralewayRegularFont,
            color: rgb(0.2, 0.2, 0.2),
         });

      basicdata.objekttitel &&
         drawTextWithWrap(firstPage, basicdata.objekttitel, {
            x: 29,
            y: height - 35,
            size: 12,
            font: ralewayRegularFont,
            maxWidth: 280, // Text bricht nach 400 Punkten um
            lineHeight: 1.4, // Optionaler Zeilenabstand
         });

      basicdata.objektart &&
         firstPage.drawText(fieldconfiguration.estate.objektart.permittedvalues[basicdata.objektart], {
            x: 75,
            y: height - 360,
            size: 10,
            font: ralewayRegularFont,
            // color: rgb(0, 0, 0),
            color: rgb(0.2, 0.2, 0.2),
         });
      basicdata.zustand &&
         firstPage.drawText(fieldconfiguration.estate.zustand.permittedvalues[basicdata.zustand], {
            x: 75,
            y: height - 398,
            size: 10,
            font: ralewayRegularFont,
            color: rgb(0.2, 0.2, 0.2),
         });
      basicdata.baujahr &&
         firstPage.drawText(basicdata.baujahr, {
            x: 75,
            y: height - 436,
            // y: 146,
            size: 10,
            font: ralewayRegularFont,
            color: rgb(0.2, 0.2, 0.2),
         });

      basicdata.anzahl_zimmer &&
         firstPage.drawText("" + parseInt(basicdata.anzahl_zimmer), {
            x: 260,
            y: height - 360,
            size: 10,
            font: ralewayRegularFont,
            color: rgb(0.2, 0.2, 0.2),
         });
      basicdata.wohnflaeche &&
         firstPage.drawText("ca. " + parseInt(basicdata.wohnflaeche) + "m²", {
            x: 260,
            y: height - 398,
            size: 10,
            font: ralewayRegularFont,
            color: rgb(0.2, 0.2, 0.2),
         });

      if (basicdata.objektart === "haus") {
         basicdata.grundstuecksflaeche &&
            firstPage.drawText("ca. " + parseInt(basicdata.grundstuecksflaeche) + "m²", {
               x: 260,
               y: height - 436,
               size: 10,
               font: ralewayRegularFont,
               color: rgb(0.2, 0.2, 0.2),
            });
      } else {
         basicdata.dbwa_etage &&
            firstPage.drawText(basicdata.dbwa_etage, {
               x: 260,
               y: height - 436,
               size: 10,
               font: ralewayRegularFont,
               color: rgb(0.2, 0.2, 0.2),
            });
      }

      basicdata.kaufpreis &&
         firstPage.drawText(formatCurrency(basicdata.kaufpreis), {
            x: 260,
            y: height - 512,
            size: 10,
            font: ralewayRegularFont,
            color: rgb(0.2, 0.2, 0.2),
         });

      /* ------------- */
      let eaVorliegend = true;
      if (
         basicdata.energieausweistyp &&
         fieldconfiguration.estate.energieausweistyp.permittedvalues[basicdata.energieausweistyp] ===
            "liegt zur Besichtigung vor"
      ) {
         eaVorliegend = false;
      }

      console.log(fieldconfiguration.estate.energieausweistyp.permittedvalues[basicdata.energieausweistyp]);

      basicdata.energieausweistyp &&
         firstPage.drawText(
            basicdata.energieausweistyp
               ? eaVorliegend
                  ? fieldconfiguration.estate.energieausweistyp.permittedvalues[basicdata.energieausweistyp]
                  : "in Erstellung"
               : "",
            {
               // x: 145,
               x: 155,
               y: height - 456.5,
               size: 6,
               font: ralewayRegularFont,
               color: rgb(0.2, 0.2, 0.2),
            },
         );

      firstPage.drawText(
         basicdata.heizungsart && basicdata.heizungsart.length
            ? fieldconfiguration.estate.heizungsart.permittedvalues[basicdata.heizungsart[0]]
            : "",
         {
            x: 155,
            y: height - 466.5,
            size: 6,
            font: ralewayRegularFont,
            color: rgb(0.2, 0.2, 0.2),
         },
      );

      firstPage.drawText(
         basicdata.befeuerung && basicdata.befeuerung.length
            ? fieldconfiguration.estate.befeuerung.permittedvalues[basicdata.befeuerung[0]]
            : "",
         {
            x: 155,
            y: height - 477,
            size: 6,
            font: ralewayRegularFont,
            color: rgb(0.2, 0.2, 0.2),
         },
      );

      (basicdata.energieverbrauchskennwert || basicdata.endenergiebedarf) &&
         firstPage.drawText(
            eaVorliegend
               ? (basicdata.energieausweistyp === "Energieverbrauchskennwert" ||
                 basicdata.energieausweistyp === "Verbrauchsausweis Gewerbe"
                    ? basicdata.energieverbrauchskennwert
                    : basicdata.endenergiebedarf) + "kWh/(m²a)"
               : "-",
            {
               x: 320,
               y: height - 456.4,
               size: 6,
               font: ralewayRegularFont,
               color: rgb(0.2, 0.2, 0.2),
            },
         );

      firstPage.drawText(
         basicdata.energieausweistyp === "Energieverbrauchskennwert" ||
            basicdata.energieausweistyp === "Verbrauchsausweis Gewerbe"
            ? "Energieverbrauch:"
            : "Energiebedarf:",
         {
            x: 213.4,
            y: height - 456.4,
            size: 6,
            font: ralewayRegularFont,
            color: rgb(0.2, 0.2, 0.2),
         },
      );

      firstPage.drawText(
         eaVorliegend
            ? basicdata.energyClass && fieldconfiguration.estate.energyClass.permittedvalues[basicdata.energyClass]
            : "-",
         {
            x: 320,
            y: height - 466,
            size: 6,
            font: ralewayRegularFont,
            color: rgb(0.2, 0.2, 0.2),
         },
      );

      basicdata.energieausweis_gueltig_bis &&
         firstPage.drawText(
            eaVorliegend
               ? basicdata.energieausweis_gueltig_bis
                  ? new Date(basicdata.energieausweis_gueltig_bis).toLocaleDateString()
                  : ""
               : "-",
            {
               x: 320,
               y: height - 476,
               size: 6,
               font: ralewayRegularFont,
               color: rgb(0.2, 0.2, 0.2),
            },
         );
      // energieausweistyp
      const pdfBytes = await pdfDoc.save();

      const blob = new Blob([pdfBytes], { type: "application/pdf" });

      var a = document.createElement("a");
      document.body.appendChild(a);
      a.style = "display: none";
      const url = window.URL.createObjectURL(blob);
      a.href = url;
      a.download = "Aushang_" + basicdata.objektnr_extern + ".pdf";
      a.click();
      window.URL.revokeObjectURL(url);
   }

   /**
    * Hilfsfunktion zum Zeichnen von Text mit Zeilenumbruch
    */
   function drawTextWithWrap(page, text, settings) {
      const { x, y, size, font, maxWidth, lineHeight = 1.2 } = settings;

      const words = text.split(" ");
      let line = "";
      let currentY = y;

      for (let n = 0; n < words.length; n++) {
         const testLine = line + words[n] + " ";
         const testWidth = font.widthOfTextAtSize(testLine, size);

         if (testWidth > maxWidth && n > 0) {
            // Aktuelle Zeile zeichnen
            page.drawText(line, { x, y: currentY, size, font });
            // Zeile zurücksetzen und Y-Position nach unten schieben
            line = words[n] + " ";
            currentY -= size * lineHeight;
         } else {
            line = testLine;
         }
      }
      // Die letzte verbleibende Zeile zeichnen
      page.drawText(line, { x, y: currentY, size, font });
   }

   return (
      <>
         {
            <div style={{ position: "relative" }}>
               <button
                  onClick={() => {
                     createAushang();
                  }}
                  className="custom-group-button"
                  /* style={{
                     position: "absolute",
                     right: "120px",
                     zIndex: 0,
                  }} */
                  title="Aushang runterladen"
               >
                  <img src={downloadIcon} />
               </button>
            </div>
         }
      </>
   );
}
